import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

export interface taskStatusInterface {
	emailApproval?: string;
	task?: string;
	statusTask?: string;
	nameApproval?: string;
	predecessor?: string;
	task_id?: number | string;
	idAnalystTask?: string;
}

@Injectable({
	providedIn: 'root',
})
export class RequestTaskService {
	updateTaskUrl = environment.baseApiUrl + 'request/{requestID}/task';
	getTaskUrl = environment.baseApiUrl + 'request/{requestID}/taskStatus';

	constructor(private HttpClient: HttpClient) {}

	updateTask(
		requestId: string,
		idRequestTask: string,
		status: string,
		notes?: string,
		email?: string,
		language?: string,
		htmlEmail?: string,
		gmt?: string,
		predecessorTask?: string,
		analyst?: string
	): Observable<JSON[]> {
		const parameters = new HttpParams().set('email', email).set('language', language).set('htmlEmail', htmlEmail).set('gmt', gmt);
		const updateTaskUrl = this.updateTaskUrl.replace('{requestID}', requestId);
		const content = {
			idTask: idRequestTask,
			status: status,
			notes: notes == '' ? '' : notes,
			predecessor: predecessorTask == '' ? '' : predecessorTask,
			idAnalystTask: analyst,
			attachmentTask: {
				checkSum: '',
				content: '',
				extension: '',
				filePath: '',
				mimeType: '',
				name: '',
			},
		};

		return this.HttpClient.put<JSON[]>(updateTaskUrl, content, { params: parameters });
	}

	getTask(requestId: string, id?: string, taskId?: string): Observable<taskStatusInterface[]> {
		let getTaskUrl = this.getTaskUrl.replace('{requestID}', requestId);

		if (id && id !== '') {
			getTaskUrl += `?id=${id}`;
		} else if (taskId && taskId !== '') {
			getTaskUrl += `?task_id=${taskId}`;
		}

		return this.HttpClient.get<taskStatusInterface[]>(getTaskUrl).pipe(
			map((taskStatus) => {
				if (taskStatus.length === 0) {
					return taskStatus;
				}

				const tasks: taskStatusInterface[] = [];
				for (const element of taskStatus) {
					const task: taskStatusInterface = {
						emailApproval: element.emailApproval,
						task: element.task,
						statusTask: element.statusTask,
						nameApproval: element.nameApproval,
						predecessor: element.predecessor,
						task_id: element.task_id,
						idAnalystTask: element.idAnalystTask,
					};

					tasks.push(task);
				}

				return tasks;
			})
		);
	}
}
